import { axiosPostData } from "../../Survey/helpers/fetch_services";
import { normalizeId } from "../../Survey/pages/ClientConnectV2/survey/surveyPreviewUtils";
import { mapLearningSubmitResponse } from "./mapLearningSubmitResponse";
function appendAnswerFiles(formData, answersClone, filesArray) {
  if (!filesArray.length) {
    return;
  }

  filesArray.forEach((item) => {
    const key = Object.keys(item)[0];
    const { questionType } = answersClone[key] || {};
    let images = [];

    if (questionType === "file") {
      if (item[key]?.value?.length) {
        item[key].value.forEach((img) => images.push(img));
      }
      if (item[key]?.image?.length) {
        item[key].image.forEach((img) => images.push(img));
      }
    } else {
      images = item[key]?.image || [];
    }

    if (images.length) {
      images.forEach((image) => {
        formData.append(key, image);
      });
    }
  });
}

/** Keeps only answers for currently visible questions (hide/route/location), like Normal submit. */
function filterAnswersToVisibleQuestions(answers, questions) {
  const visibleIds = new Set(
    (questions || [])
      .map((question) => normalizeId(question?._id))
      .filter(Boolean),
  );

  return Object.fromEntries(
    Object.entries(answers || {}).filter(([answerId]) =>
      visibleIds.has(normalizeId(answerId)),
    ),
  );
}

/** Builds FormData for `survey/answerSurvey` from L&D knowledge-check answers. */
export function buildLearningAnswerSurveyFormData({
  answers,
  questions,
  surveyId,
  inviteId,
  userId,
  packageId,
  attemptNumber,
}) {
  const visibleAnswers = filterAnswersToVisibleQuestions(answers, questions);
  const answersClone = JSON.parse(JSON.stringify(visibleAnswers));
  const filesArray = [];

  Object.keys(visibleAnswers).forEach((item) => {
    const question = questions.find(
      (q) => normalizeId(q._id) === normalizeId(item),
    );

    if (question && visibleAnswers[item] && "isFile" in visibleAnswers[item]) {
      answersClone[item] = {
        ...answersClone[item],
        questionType:
          question.questionType === "handwrittenInput"
            ? "base64"
            : question.questionType,
      };
      filesArray.push({ [item]: visibleAnswers[item] });
    }
  });

  const metaData = {
    survey_id: surveyId || "",
    invite_id: inviteId || "",
    response_user_id: userId || "",
    package_id: packageId || "",
    attempt_number: attemptNumber,
    ld_invite_id: inviteId || "",
    ld_package_id: packageId || "",
  };

  const companyId = localStorage.getItem("company_id");
  if (companyId) {
    metaData.company_id = companyId;
  }

  const formData = new FormData();
  formData.append("metaData", JSON.stringify(metaData));
  formData.append("jsonData", JSON.stringify(answersClone));
  formData.append("responseData", JSON.stringify({}));
  formData.append("director_message", "");
  formData.append("ticketCreatorId", "");

  if (companyId) {
    formData.append("company_id", companyId);
  }

  appendAnswerFiles(formData, answersClone, filesArray);

  return formData;
}

export async function submitLearningSurvey(params) {
  const formData = buildLearningAnswerSurveyFormData(params);
  const response = await axiosPostData("survey/answerSurvey", formData, {
    preserveSessionOn401: true,
  });

  if (!response || response.status < 200 || response.status >= 300) {
    return { success: false };
  }

  const result = mapLearningSubmitResponse(response, {
    questionCount: params.questionCount,
  });

  if (!result) {
    return { success: false };
  }

  return {
    success: true,
    ...result,
  };
}